const mixin = {
  mounted() {
    // if (process.env.NODE_ENV === 'production') {
    setTimeout(() => {
      this.$_getUserInfo();
    }, 300);
    // }
  },
  methods: {
    /**
     * 关闭h5 返回原生app
     * @return {[type]} [description]
     */
    $_headerLeftClick(type = 'prev') {
      this.$bridge.callHandler('finish', { msg: '关闭h5', to: type }, () => {
      });
    },
    $_getUserInfo() {
      this.$bridge.callHandler('getUserInfo', { msg: '获取用户信息' }, (data) => {
        const obj = JSON.parse(data);
        this.$store.dispatch('changeAu', obj.au).then(() => {
          this.$store.dispatch('changeManagerInfo', JSON.parse(obj.managerInfo)).then(() => {
          });
        });
      });
    },
  },
};

export default mixin;
